import { Dispatch, SetStateAction, useState } from "react";
import {
  Modal,
  Button,
  MenuItem,
  Select,
  TextField,
  Chip,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddReferenceModal({
  open,
  onClose,
  setOpen,
}: ModalProps) {
  const [categoryTags, setCategoryTags] = useState<string[]>([]);
  const [tagInput, setTagInput] = useState("");

  const addTag = () => {
    if (tagInput.trim() && !categoryTags.includes(tagInput.trim())) {
      setCategoryTags([...categoryTags, tagInput.trim()]);
      setTagInput("");
    }
  };

  const removeTag = (tag: string) => {
    setCategoryTags(categoryTags.filter(t => t !== tag));
  };

  return (
    <Modal className="modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">

          {/* Header */}
          <div className="modal_title">
            <h2>Add Reference</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form */}
          <form className="form">
            <div className="gap_p">

              {/* Name */}
              <div className="control_group">
                <label htmlFor="reference-name">Name</label>
                <TextField
                  placeholder="e.g. UAE Fashion Industry 2024"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "reference-name" }}
                />
              </div>

              {/* Type */}
              <div className="control_group">
                <label htmlFor="reference-type">Type</label>
                <Select fullWidth defaultValue="" displayEmpty inputProps={{ id: "reference-type" }}>
                  <MenuItem value="" disabled>Select Type</MenuItem>
                  <MenuItem value="uae_market">UAE market</MenuItem>
                  <MenuItem value="category">Category</MenuItem>
                  <MenuItem value="historical">Historical</MenuItem>
                  <MenuItem value="external">External</MenuItem>
                </Select>
              </div>

              {/* URL */}
              <div className="control_group">
                <label htmlFor="reference-url">URL</label>
                <TextField
                  placeholder="https://example.com/report"
                  fullWidth
                  hiddenLabel
                  inputProps={{ id: "reference-url" }}
                />
              </div>

              {/* Category Tags */}
              <div className="control_group">
                <label htmlFor="category-tag-input">Category Tags</label>

                <Box display="flex" gap={1}>
                  <TextField
                    placeholder="Add tag..."
                    value={tagInput}
                    onChange={(e) => setTagInput(e.target.value)}
                    fullWidth
                    hiddenLabel
                    inputProps={{ id: "category-tag-input" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        addTag();
                      }
                    }}
                  />
                  <Button
                    variant="contained"
                    className="btn btn_grey"
                    onClick={addTag}
                  >
                    Add
                  </Button>
                </Box>

                {/* Tags List */}
                {categoryTags.length > 0 && (
                  <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                    {categoryTags.map((tag) => (
                      <Chip
                        key={tag}
                        label={tag}
                        onDelete={() => removeTag(tag)}
                        size="small"
                      />
                    ))}
                  </Box>
                )}
              </div>

            </div>

            {/* Footer */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => setOpen(false)}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Save
              </Button>
            </div>
          </form>

        </div>
      </div>
    </Modal>
  );
}
